import React, { ComponentType, PropsWithChildren } from 'react';
import { styled } from '@cp/ds/src/theme';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { Tokens, name } from './const';
import { DialogContainer } from './container';

const Pinned = styled(Box, { name, slot: 'Pinned' })({
  display: 'flex',
  flexDirection: 'column',
  gap: Tokens.listGap(),
  marginBlockStart: Tokens.listGap(),
  marginBlockEnd: Tokens.listGap(),
  '&:empty': { display: 'none' },
}) as unknown as ComponentType<BoxProps>;

export const PinnedWrapper = (props: PropsWithChildren) => (
  <DialogContainer>
    <Pinned>{props.children}</Pinned>
  </DialogContainer>
);
